export enum SessionStorageKeys {
  CompetitionSubmitted = 'competitionSubmitted',
  SearchMethod = 'searchMethod',
  CartTrackingData = 'cartTrackingData',
  HideLoginTooltip = 'hideLoginTooltip',

  // Algolia
  AlgoliaInsights = 'algolia-insights',
  PdpServiceSelection = 'pdp-service-selections',
  PdpSelectedServiceSuggestion = 'pdp-selected-service-suggestion',

  // Cart
  CachedCart = 'cachedCart',

  //Coupon
  CouponLocation = 'couponLocation',
}

//
// Functions for session storage actions
//

/**
 * Set to sessionStorage
 */
export const setSession = (key: SessionStorageKeys, data: any, isJson = false) => {
  if (!window.sessionStorage) return;

  if (data === undefined || data === null || data === '') {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      console.error('setSession: removeItem failed', err);
    }
    return;
  }

  try {
    const value = isJson ? JSON.stringify(data) : String(data);
    sessionStorage.setItem(key, value);
  } catch (e) {
    console.error('Failed to serialize JSON', e);
  }
};

/**
 * Get from sessionStorage
 */
export const getSession = <T = any>(key: SessionStorageKeys, isJson = false) => {
  if (!window.sessionStorage) return;

  const raw = sessionStorage.getItem(key);

  if (raw === null || raw === '' || raw === 'undefined' || raw === 'null') return;

  if (isJson) {
    try {
      return JSON.parse(raw) as T;
    } catch (err) {
      console.error('getSession: JSON.parse failed', err);
      return;
    }
  }

  return raw as T;
};

/**
 * Remove sessionStorage
 */
export const removeSession = (key: SessionStorageKeys) => {
  if (!window.sessionStorage) {
    return;
  }

  sessionStorage.removeItem(key);
};
